import { safeStorage } from '@/lib/storage'
import { uuid } from '@/lib/uuid'

const KEY = 'angadi.device_id'

/** Anonymous per-device id for analytics logs (BR-13, D-10). No personal data. */
export function getDeviceId(): string {
  let id = safeStorage.get(KEY)
  if (!id) {
    id = uuid()
    safeStorage.set(KEY, id)
  }
  return id
}
